import { render } from "./ShareGalleryModalComponent.vue?vue&type=template&id=508ed478&ts=true"
import script from "./ShareGalleryModalComponent.vue?vue&type=script&lang=ts"
export * from "./ShareGalleryModalComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__